import { inject, Injectable, linkedSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';

export type PageStyle = 'default' | 'standalone' | 'no-nav';

@Injectable({ providedIn: 'root' })
export class PageStyleService {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  private readonly routerPageStyle = toSignal(
    this.router.events.pipe(
      filter((ev) => ev instanceof NavigationEnd),
      map(() => this.getPageStyleFromRoute()),
    ),
  );

  // use linkedSignal to allow overriding page style
  readonly pageStyle = linkedSignal(() => this.routerPageStyle());

  private getPageStyleFromRoute() {
    let child = this.activatedRoute.firstChild;
    let lastStyle: PageStyle = 'default';

    // Look for the deepest child that has pageStyle set
    // We can't just use the first child as it's unknown how deep a route will be that sets the page style.
    // TODO: determine whether we should just look for the first route with pageStyle
    // and only allow overrides via the `pageStyle` signal.
    while (child) {
      if (child.snapshot.data && child.snapshot.data['pageStyle']) {
        lastStyle = child.snapshot.data['pageStyle'];
      }

      child = child.firstChild;
    }

    return lastStyle;
  }
}
